import styled from 'styled-components'
import { BLUE,  WHITE } from '../colors'

import React, {PureComponent} from 'react'

import {Link} from 'react-router-dom'

const StyledPagination = styled.div`
    display:flex;
    justify-content:center;
    a{
        text-decoration:none;
    }
`

const StyledPageLink = styled.span`
    display:inline-block;
    padding:5px;
    margin:5px;
    width:2em;
    height:2em;
    display:flex;
    justify-content:center;
    align-items:center;
    border:1px solid ${BLUE};
    color:${({active})=> active ? WHITE : BLUE};
    text-decoration:none;
    background:${({active})=> active ? BLUE : WHITE};
`

export default class Pagination extends PureComponent{

    render(){
        const {page = 1, perPage, itemCount, getPageLink} = this.props
        console.log('pagination', page, perPage, itemCount, Math.floor(itemCount/perPage))
        const pageCount = Math.floor(Number(itemCount)/Number(perPage)) + 1
        let pageLinks = []
        for(var i = 1;i<=pageCount;i++){
            pageLinks.push({
                page:i,
                label: `${i}`,
                to: getPageLink({index:i})
            })
        }
        let padding = 10
        let leftPadding = page - padding
        let leftOverflow = Math.min(0,0 - leftPadding)
        let rightPadding = page + padding
        let rightOverflow = Math.max(pageCount, rightPadding)
        let left = Math.max(0, leftPadding - rightOverflow) 
        let right = Math.min(pageCount, rightPadding - leftOverflow) 
        console.log('pagination', left, page, right)
        pageLinks = pageLinks.slice(left, right)
        return <StyledPagination>
            {pageLinks.map((pageLink)=>{
                const active = pageLink.page == page
                return (<Link key={pageLink.page} to={pageLink.to}>
                    <StyledPageLink active={active}>
                        {pageLink.label}
                    </StyledPageLink>
                </Link>)
            })}
        </StyledPagination>
    }


}


// WEBPACK FOOTER //
// ./src/components/ui/pagination.js